<script>
export default {
    props: {
        date: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            showMenu: false,
            dayFull: false,
            earlyStart: false,
            overnight: false,
        };
    },
    computed: {
        isDayFull: function () {
            return this.$store.getters['resourceCalendar/isDayFull'](this.date, this.resource);
        },
        isDayEarlyStart: function () {
            return this.$store.getters['resourceCalendar/isDayEarlyStart'](this.date, this.resource);
        },
        isDayOvernight: function () {
            return this.$store.getters['resourceCalendar/isDayOvernight'](this.date, this.resource);
        },
    },
    watch: {
        showMenu(newVal) {
            this.$emit('menu-toggle', newVal);
        },
        isDayFull: {
            immediate: true,
            handler(newVal) {
                this.dayFull = newVal;
            }
        },
        isDayEarlyStart: {
            immediate: true,
            handler(newVal) {
                this.earlyStart = newVal;
            }
        },
        isDayOvernight: {
            immediate: true,
            handler(newVal) {
                this.overnight = newVal;
            }
        },
    },
    beforeDestroy() {
        if (this.showMenu) {
            this.$emit('menu-toggle', false);
        }
    },
    methods: {
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        handleDayFullToggle() {
            this.$store.dispatch('resourceCalendar/toggleDay', {date: this.date, resource: this.resource, type: 'Full Day'})
        },
        handleDayEarlyStartToggle() {
            this.$store.dispatch('resourceCalendar/toggleDay', {date: this.date, resource: this.resource, type: 'Early Start'})
        },
        handleDayOvernightToggle() {
            this.$store.dispatch('resourceCalendar/toggleDay', {date: this.date, resource: this.resource, type: 'Overnight'});
        },
    },
}
</script>

<template>
    <div class="day-options">
        <button
            class="day-options-toggle"
            type="button"
            title="Show Day Options"
            @click="toggleMenu"
        >
            <i class="fas fa-ellipsis-h" />
        </button>
        <div
            v-if="showMenu"
            class="day-options-bg"
            @click="showMenu = false"
        />
        <div
            v-if="showMenu"
            class="day-options-fg"
        >
            <div>
                <label>
                    <input
                        type="checkbox"
                        v-model="dayFull"
                        @input="handleDayFullToggle"
                    >
                    <span>Day Full</span>
                </label>
            </div>
            <div>
                <label>
                    <input
                        type="checkbox"
                        v-model="earlyStart"
                        @input="handleDayEarlyStartToggle"
                    >
                    <span>Early Start</span>
                </label>
            </div>
            <div>
                <label>
                    <input
                        type="checkbox"
                        v-model="overnight"
                        @input="handleDayOvernightToggle"
                    >
                    <span>Overnight</span>
                </label>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.day-options {
    display: block;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;

    &-toggle {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 1.2rem;
        padding: 0.2rem;
        color: #6b6b6b;

        &:hover {
            color: #000;
        }
    }

    &-bg {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: transparent;
        z-index: 10;
    }

    &-fg {
        position: absolute;
        top: 1.8rem;
        right: 0;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        z-index: 20;
        padding: 0.5rem;
        min-width: 150px;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/calendar/DayOptions.vue